import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import { convertSeconds } from '@pv-frontend/pv-shared-services/utils/time';
import * as i1 from '@angular/common';
import { DecimalPipe } from '@angular/common';

class PvCountdownFormatPipe {
    constructor(decimalPipe) {
        this.decimalPipe = decimalPipe;
    }
    transform(secondsValue, showZeroHours = false, showZeroMinutes = true, showSuffix) {
        const { days, hours, minutes, seconds } = convertSeconds(secondsValue);
        const daysFragment = this.evaluateAndFormat(days, showZeroHours, showSuffix ? 'd' : '');
        const hoursFragment = this.evaluateAndFormat(hours, showZeroHours, showSuffix ? 'h' : '');
        const minutesFragment = this.evaluateAndFormat(minutes, showZeroMinutes, showSuffix ? 'm' : '');
        const secondsFragment = `${this.formatValue(seconds)}${showSuffix ? 's' : ''}`;
        return `${daysFragment}${hoursFragment}${minutesFragment}${secondsFragment}`;
    }
    formatValue(value) {
        return this.decimalPipe.transform(value, '2.0') ?? '';
    }
    evaluateAndFormat(value, showZeroValue, suffix) {
        if ((value === 0 && showZeroValue) || value !== 0) {
            return `${this.formatValue(value)}${suffix ? `${suffix} ` : ':'}`;
        }
        return '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: PvCountdownFormatPipe, deps: [{ token: i1.DecimalPipe }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.8", ngImport: i0, type: PvCountdownFormatPipe, name: "countdownFormat" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: PvCountdownFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'countdownFormat',
                    pure: true,
                }]
        }], ctorParameters: () => [{ type: i1.DecimalPipe }] });

class PvCountdownPipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: PvCountdownPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.8", ngImport: i0, type: PvCountdownPipeModule, declarations: [PvCountdownFormatPipe], exports: [PvCountdownFormatPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: PvCountdownPipeModule, providers: [DecimalPipe] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: PvCountdownPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PvCountdownFormatPipe],
                    providers: [DecimalPipe],
                    exports: [PvCountdownFormatPipe],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { PvCountdownFormatPipe, PvCountdownPipeModule };
